import { createClient } from "@supabase/supabase-js"

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
// Show passkey controls only after the Auth project is configured with this app's RP ID and origin.
export const isPasskeyEnabled = import.meta.env.VITE_ENABLE_PASSKEY_AUTH === "true"

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Missing Supabase environment variables:", {
    VITE_SUPABASE_URL: supabaseUrl ? "SET" : "MISSING",
    VITE_SUPABASE_ANON_KEY: supabaseAnonKey ? "SET" : "MISSING",
  })
  throw new Error("Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY")
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    experimental: { passkey: true },
  },
})
